function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cuid from 'cuid';
import Theme from '../Theme';
import { Data } from './data';
var palette = Theme.palette;
/**
 * Predefined sizes
 */

var SIZE = {
  small: 10,
  medium: 20,
  large: 30
};
/**
 * Icon comnponent
 *
 * See README, run storybook or see propTypes below for documentation
 *
 * @return {jsx}
 */

var Icon = function Icon(_ref) {
  var className = _ref.className,
      color = _ref.color,
      name = _ref.name,
      size = _ref.size,
      title = _ref.title,
      restProps = _objectWithoutProperties(_ref, ["className", "color", "name", "size", "title"]);

  var generatedId = cuid();
  var titleElementId = "icon-title-".concat(generatedId);
  /**
   * Get icon size
   *
   * @return {string}
   */

  var getIconSize = useMemo(function () {
    if (SIZE.hasOwnProperty(size)) return SIZE[size];
    return size;
  }, [size]);
  /**
   * Get color
   *
   * @return {string}
   */

  var getColor = useMemo(function () {
    if (palette.hasOwnProperty(color)) return palette[color];
    return color;
  }, [color]);
  /**
   * Get icon path
   *
   * @return {string}
   */

  var getIconPath = Data[name];
  /**
   * Icon element
   */

  var IconElement = typeof getIconPath === 'function' && getIconPath;

  var rootProps = _objectSpread({
    'aria-hidden': title ? undefined : true,
    'aria-labelledby': title && titleElementId,
    focusable: 'false',
    height: getIconSize,
    role: 'img',
    viewBox: '0 0 512 512',
    width: getIconSize
  }, restProps);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    xmlns: "http://www.w3.org/2000/svg"
  }, rootProps), title && /*#__PURE__*/React.createElement("title", {
    id: titleElementId
  }, title), /*#__PURE__*/React.createElement("g", null, !IconElement ? /*#__PURE__*/React.createElement("path", {
    "data-testid": "icon-svg-path",
    fill: getColor,
    fillRule: "evenodd",
    d: getIconPath
  }) : /*#__PURE__*/React.createElement(IconElement, {
    fill: getColor
  })));
};
/**
 * PropTypes Validation
 */


var number = PropTypes.number,
    oneOfType = PropTypes.oneOfType,
    string = PropTypes.string;
Icon.propTypes = {
  /**
   * className needed by styled component
   */
  className: string,

  /**
   * Fill color
   */
  color: string,

  /**
   * Icon name
   */
  name: string.isRequired,

  /**
   * Available sizes, including custom - e.g. '20px'
   */
  size: oneOfType([number, string]),

  /**
   * Alternative text
   */
  title: string
};
/**
 * Default props.
 */

Icon.defaultProps = {
  className: undefined,
  color: 'white',
  size: SIZE.medium,
  title: null
};
/**
 * Display name
 */

Icon.displayName = 'Icon';
export default styled(Icon).withConfig({
  displayName: "Icon",
  componentId: "sc-16s5lkr-0"
})(["display:inline-block;"]);